export const collections = [
  {
    id: 'gratia-dei-children',
    title: 'Catehismul pentru copii',
    description: 'Catehismul pentru copii Gratia Dei',
  },
  {
    id: 'baptist',
    title: 'Catehismul baptist',
    description: 'Catehismul baptist',
  },
  // {
  //   id: 'heidelberg',
  //   title: 'Catehismul de la Heidelberg',
  //   description: 'Lorem ipsum dolor sit amet',
  // },
  // {
  //   id: 'westminster-small',
  //   title: 'Catehismul mic de la Westminster',
  //   description: 'Lorem ipsum dolor sit amet',
  // },
]
